export default {
  months: {
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
  },
  all: 'all',
  day: 'day',
  one_month: '1 month',
  three_months: '3 months',
  six_months: '6 months',
  one_year: '1 year',
  increase: 'increase',
  deduction: 'Deduction',
  new: 'The latest',
  past: 'past',
  memo: 'Memo',
  enter_memo: 'Please enter a note.',
  price: 'Price',
  enrollment: 'Enrollment',
  re_enter: 'Re-enter',
  registration_complete_txt: 'Registration is complete',
  registration_failed_txt: 'Registration has failed.',
  bank_name: 'Bank Name',
  locale_name: 'English',
  sale_registration: 'Sale registration',
  apply: 'Apply',
  status: 'Status',
  wallet: 'Wallet',
  buy: 'Buy',
  sell: 'Sell',
  breakdown: 'Breakdown',
  act_buy: 'Buy',
  act_sell: 'Sell',
  asset: 'Asset',
  select: 'Select',
  no_select: 'No choice',
  account: 'Account',
  balance: 'Balance',
  login: 'Login',
  logout: 'Logout',
  register: 'Join As Member',
  select_cancel: 'Uncheck',
  cancel: 'Cancel',
  modify: 'Modify',
  auto_input: '(Automatic input)',
  confirm: 'Confirm',
  look_up: 'Lookup',
  password: 'Password',
  account_delete: 'Secession',
  detail: 'Detail',
  list_detail: 'More Details',
  birth: 'Birth',
  welcome: 'Welcome',
  please_login: 'Please login',
  confirmation_login: 'You can check it when you log in.',
  id: 'ID',
  find_id: 'Forgot your ID',
  find_password: 'Forgot your password',
  back: 'Back',
  agreement: 'Terms of agreement',
  info_input: 'Input information',
  success: 'Complete',
  agree_msg: 'I agree.',
  all_agree: 'I agree to all',
  agree: 'Agree',
  confirm_password: 'Confirm Password',
  repeat_password: 'Confirm Password',
  next: 'Next',
  before: 'Go Back',
  register_success: 'Sign Up now.',
  verify: 'Confirm',
  retention: 'Possesion',
  allow: '(permit)',
  disallow: '(Unacceptable)',
  upload_btn: 'Upload',
  continue_entry: 'Please enter "[+:verification]" below to continue',
  login_msg_1: 'Try a coin-related account on ONEWORLDPAY !',
  login_msg_2:
    'Please use transactions and wallets and services through our ONEWORLDPAY.',
  login_msg_3: 'ONEWORLDPAY supports all environments',
  cocofx_register: 'Register ONEWORLDPAY',
  register_msg_1:
    'Join as Member. <br /> Please agree to our terms and conditions',
  register_msg_3:
    'A ONEWORLDPAY account will give access for all services at ease.',
  register_msg_all:
    'Consent to all includes consent to required and optional items, and you can select consent individually. Even if you refuse to agree to the options, the service is available.',
  register_title: 'I am above the age of 19 and older.',
  register_title_2: 'ONEWORLDPAY Terms',
  register_title_3: 'ONEWORLDPAY Integrated Terms of Service',
  register_title_4: 'ONEWORLDPAY marketing leverage agreed',
  register_title_5: 'Consent to Collection and Use of Personal Information',
  register_title_6: 'Consent to Collect and Use Location Information',
  register_title_7: 'Agree to collect additional profile information',
  register_title_8: 'Input ONEWORLDPAY Account Information',
  register_title_9: 'Input Information',
  register_msg_4:
    'These terms apply to all the services provided by the company. <br /> By agreeing to these terms, you can use these services without signing a separate contract.',
  required: '[Required]',
  option: '[Selective]',
  otp_notice: 'The state is activated and deactivated OTP impossible.',
  required_check: 'Please check all required fields',
  check_input: 'Please enter all the details.',
  register_guide: 'How to Use ONEWORLDPAY',
  register_step1: 'Click COCO BANK Button',
  register_step2: 'Login to COCO BANK',
  register_step3: 'Pay/Recharge COCO BANK Log In',
  copy: 'Copy',
  no_account: 'There is no registered accounts.',
  inviter_link: 'Referral links',
  register_used_account: 'Register frequently used accounts',
  security_certification: 'Security Certification',
  company: 'Company',
  exact_calculation: 'Exact calculation',
  profile: 'Profile',
  inquiry: 'Inquiry',
  announcement: 'Announcement',
  information: 'Information',
  history: 'History',
  registration_date: 'Registration date',
  pay: 'payment',
  detail_search: 'Detailed search',
  market: 'market',
  holding: 'Holding',
  fee_charged: 'Fee charged',
  type_of_charge: 'Type of charge',
  auto: 'Automatic',
  manual: 'Manual',
  s_usdt_protocol: 'Choose a Tether Protocol',
  header: {
    c2c_enroll: 'Purchase / Sale Registration',
    wallet_list: 'Inquiry',
    wallet: 'Wallet',
    c2c_list: 'Purchase / Sales history',
    no_c2c_sell_list: 'There is no sales history.',
    transfer_list: 'Currency change',
    no_transfer_list: 'There is no exchange history.',
    withdrawal_list: 'Deposits / Withdrawals',
    my_info: 'My Info',
    home: 'Main',
    payment_history: 'Payment history',
    account_transfer: 'Account transfer',
    transfer_history: 'Transfer history',
    register_used_account: 'Register frequently used accounts',
    exchange: 'Currency exchange',
    exchange_store: 'Exchange',
    exchange_list: 'Currency exchange history',
    email: 'e-mail',
    email_list: 'Email history',
    otp: 'OTP',
    otp_list: 'OTP History',
    register_account: 'Register account',
    calculation_account_list: 'Exact calculation account list',
    security_certification: 'Security Certification',
    exact_calculation: 'Exact calculation',
    history: 'History',
    coco_open_market: 'COCO Open Market',
    information: 'Information',
    my_profile: 'My profile',
    email_modify: 'Edit email',
    password_modify: 'Edit your password',
    inquiry: 'Inquiry',
    inquiry_history: 'Inquiry history',
    one_on_one_inquiry: '1:1 Inquiry',
    frequently_asked_questions: 'FAQ',
    announcement: 'Announcement',
    notice: 'Notice',
    server_notice: 'Server notice',
    service_center: 'Service center',
    profile: 'Profile',
    company: 'Company',
    account_management: 'Account management',
    do_exchange: 'Currency exchange',
    transfer: 'Transfer',
    look_up: 'Lookup',
    faq: 'FAQ',
    server: 'Server',
    email_request: 'Email Request',
    Balance_transfer_history: 'Balance transfer history',
    no_balance_transfer_history:
      'There is no history of market balance movement.',
    manual: 'Manual',
  },
  header_sub: {
    exchange_list: 'Exchange',
    transfer_list: 'Transfer',
  },
  footer: {
    footer_msg: 'Try a coin-related account on ONEWORLDPAY!',
    footer_sub_msg:
      'Please use transactions and wallets and services through our ONEWORLDPAY',
    footer_sub_msg2: 'Tip',
    footer_sub_msg3: 'ONEWORLDPAY supports all environments',
    ICO: 'ICO',
    c2c: 'C2C exchange',
    b2c: 'B2C exchange',
    margin_exchange: 'Margin exchange',
    futures_exchange: 'Futures exchange',
    Binary: 'Binary options',
    open_marcket: 'Open market',
    game: 'Game',
    proceed: 'Transaction in progress',
    public: 'Go Public',
    direct_ex: 'Direct exchange',
    buy: 'Buy',
    sell: 'Sell',
    buy_sell: 'Buy / sell',
    holding_coin: 'Holding coin',
    fee: 'Fee information',
    exchange: 'Exchange',
    transfer_record: 'Transaction record',
    Leverage: 'Leverage',
    live_exchange: 'Live deal',
    demo_exchange: 'Demo deal',
    contest: 'Contest',
    powerball: 'Powerball',
    law:
      "Legal: ONEWORLDPAY.COM's registration number: 70638826927 (U 6 29 Railway Pde EastwoodNSW 2122)",
    law1:
      'Trading Point of Financial Instruments The owner of the entire Ltd (Australia) is ONEWORLDPAY PTY Ltd Registration number: 70638826927 trademark.',
    law2:
      'This Web site is powered by ONEWORLDPAY Corp. ONEWORLDPAY Corp approved number 64,190 - are under the regulation of the Auxiliary finance service, it is registered in the reference number 70638826927 Australia.',
    law3:
      'ONEWORLDPAY operates according to the Australian financial products investment guidelines.',
    law4:
      'Ref. no. 538324 | ABN reg. 70638826927 | BA reg. 64190. To make sure that you are allowed to use ONEWORLDPAY services in the legal provisions of the country of residence is the sole responsibility of the customer.',
    law5: 'Please read the Risk Disclosure professional ONEWORLDPAY.',
    law6:
      'ONEWORLDPAY does not provide services to the United States, Belize, Mauritius, Japan, Alberta, British Columbia, Quebec, Saskatchewan Residents of Saskatchewan, Haiti, Suriname, North Korea, Puerto Rico and the occupied area of ​​Cyprus.',
    law7:
      'Please refer to the regulatory part of the FAQ for more information. Please refer to our Risk Disclosure.',
    law8:
      'Restricted areas: Trading Point of Financial Instruments Ltd does not provide investment and ancillary services to third world countries and regions.',
    law_warn: 'Risk Warning:',
    law_1:
      'CFD has a high risk and complex products quickly lose their money due to leverage. 69.10% of individual investors account it will lose money when trading the CFD.',
    law_2:
      'You must consider whether you can accept the fact that you understand the CFD works, the higher the risk of losing money. Please refer to our Risk Disclosure.',
    alert_title: 'Note and Note',
    coco_market: 'COCO Market',
    ieo_market: 'IEO Market',
    news: 'News',
    event: 'Event',
    platform_rental_title: 'Platform rental',
    education: 'education',
    online_Academy: 'Online Academy',
    offline_Academy: 'Offline Academy',
    shopping_basket: 'shopping basket ',
    best_product: 'Best Deals',
    order: 'order',
    my_page_title: 'my page',
    member_info_management: 'Account Management',
    order_management: 'Order Management',
    my_question: 'my question',
    one_enquiry: '1:01 Contact',
    community: 'community',
    lotto: 'Powerball Lottery',
    rock_event: 'Rock Event',
    quiz_game: 'Trivia Game',
    ladder_game: 'Ladder',
    tetris: 'Tetris',
    split_lotto: 'Divided Lotto',
    day_Lottery: 'Daily lottery',
    attendance: 'attendance check',
    scoop_out: 'Embed',
    forum: 'forum',
  },
  b2c_exchange: {
    trading_view: 'TradingView',
    basic_chart: 'basic chart',
    today_hight: 'High price (same day)',
    today_row: 'Low price (same day)',
    tightening_strength: 'Tightening strength',
    h24_volume: 'Volume (24H)',
    h24_transaction_amount: 'Transaction amount (24H)',
    previous_days_closing_price: "Previous day's closing price",
    auxiliary_indicator: 'Auxiliary indicator',
    unlimited_number: 'You can select an unlimited number of indicators. ',
    rod_type: 'Rod type',
    chart_type: 'Chart type',
    market_name: 'Market name',
    present_price: 'Present price',
    compared_to_the_previous_day: 'Compared to the previous day',
    volume: 'Volume',
    coin_name_and_symbol_search: 'search coin name/symbol',
    event: 'Event',
    asking_price_window: 'Order Book',
    sell_order: 'Sell',
    buying_order: 'buying',
    limits: 'limits',
    maximum_order_price_quantity: 'Maximum Order Price Quantity',
    direct_input: 'Direct input',
    order_classification: 'Order classification',
    order_available: 'Order available',
    order_quantity: 'Order quantity',
    total_order_amount: 'Total order amount',
    quantity_user_fee_rate: 'Quantity User fee rate',
    quantity_creator_fee_rate: 'Quantity creator fee rate',
    reset: 'Reset',
    conclusion_price: 'Conclusion price',
    tightening_amount: 'Tightening amount',
    execution_time: 'Execution time',
    execution_price: 'Execution price',
    execution_quantity: 'Contract quantity',
    execution_amount: 'Execution amount',
    order_date_and_time: 'Order date and time',
    transaction_coin: 'Transaction Coin',
    order_price: 'Order price',
    untraded_quantity: 'Untraded quantity',
    state: 'State',
    current_price: 'Current price',
    division: 'Division',
    transaction_price: 'Transaction price',
    week52_high: '52 week maximum',
    week52_minimum: '52 weeks minimum',
    days_closing_price: "Previous day's closing price",
    same_day_high_price: 'Same day high price',
    low_price_on_the_day: 'Low price on the day',
    average_price: 'Average price',
    cumulative_quantity: 'Cumulative quantity',
    cumulative_amount: 'Cumulative amount',
    selection: 'Selection',
    minimum_ask_quantity: 'Highest ask quantity',
    save: 'Save',
    accounts_that_can_be_traded: 'There is no account available for trading.',
    won_pay: 'KRW',
    coin_order: 'Order',
    asking_price: 'Asking price',
    chart: 'Chart',
    quote: 'Quote',
    order_details: 'Order details',
    account_number: 'Account number',
    moving_quantity: 'Moving quantity',
    registration_date: 'Registration date',
  },
  main_msg: {
    about_1_title: "World's Best Cryptocurrency Trading Service",
    about_1_msg: 'ONEWORLDPAY leads all services related to coins.',
    about_1_1_msg:
      'You can buy and sell it in one place for the first time in the world.',
    about_1_2_msg: 'Direct exchange is available at ONEWORLDPAY.',
    about_2_title: 'Direct Exchange System',
    about_2_msg:
      'ONEWORLDPAY uses stable multiple parallel matching technology Advanced design technology to enable instant exchange I have a currency exchange system',
    about_3_title: 'Create Wallet',
    about_3_msg:
      'ONEWORLDPAY is composed of the best security experts in Korea. Provides a state-of-the-art security system and a WALLET system',
    about_4_title: 'Easy Trading System (C2C)',
    about_4_msg:
      'ONEWORLDPAY builds a user-friendly easy trading system Let`s make transactions easier.',
    c2c_main_msg1_1: 'ONEWORLDPAY has a currency exchange system with advanced',
    c2c_main_msg1_2:
      'design technology to enable instant exchange using stable',
    c2c_main_msg1_3: 'multiple parallel matching technology.',
    c2c_main_msg2_1:
      'ONEWORLDPAY offers top security systems and wallet system from top security professionals in the country.',
    c2c_main_msg2_2: '',
    c2c_main_msg3_1:
      ' ONEWORLDPAY has a simple, user-friendly trading system that makes it transactions easier.',
    c2c_main_msg3_2: '',
  },
  toasted_msg: {
    confirm: 'Confirmed',
    changed: 'Changed',
    withdrawal: 'Deactivated',
    register: 'Registered',
    delete: 'It has been deleted.',
    title: 'Notifications',
    exchange: 'Direct currency was successfully processed.',
    search: 'Viewed',
    deposit_request: 'Your deposit request',
    withdraw_request: 'Withdrawal requested',
    create_account: 'Opened',
    modify: 'Modified',
    cancel: 'Canceled',
    trade_confirm: 'The transaction has been confirmed.',
    trade_reject: 'Trade declined.',
    copy: 'Copied',
    nice_msg:
      'If your browser settings don`t allow pop-ups, authentication won`t proceed normally.',
    nice_title: 'Guide',
    nice_success: 'Your authentication was successful.',
    nice_error: 'I can`t authenticate myself',
    no_transfer: 'I can`t authenticate myself',
    email_auth: 'Email authentication completed successfully',
    email_auth_send: 'An authentication email has been sent',
    kyc_withdraw: 'Account verification succeeded',
    not_allow_trade: 'Trade inactive',
    id_find_mail_send: 'Your email has been sent.',
    duplicate_check: 'Duplicate ID or email.',
    pay: 'Payment is complete.',
    msg_holding: 'It was held.',
    msg_read_care: 'Note Did you read and understand the information?',
    answer_care: 'Yes, I understood it.',
    continuation: 'Continue',
    continue_entry: 'Please enter your: "[+:verification]" To continue below.',
  },
  private: {
    market_name: 'Market name',
    deal_list: 'Sales History',
    app_list: 'Purchase History',
    app_detail: 'Purchases Detail',
    deal_buy_asset: 'Assets to buy',
    buy_price: 'Purchase price',
    confirmed_source_amount: 'Confirmed sales quantity',
    holding_source_amount: 'Uncommitted sales quantity',
    potential_source_amount: 'Available quantity',
    direct_market: 'Direct exchange',
    deal_enroll: 'Sales registration',
    app_enroll: 'Purchase registration',
    select_market: 'Market select',
    fee_rate: 'Fee rate',
    free: 'Free',
    deal_info_input: 'Enter sales info',
    deal_source_amount: 'Sales quantity',
    deal_price: 'Sell price per piece',
    deal_enroll_account: 'Account for Sale Registration',
    account_select: 'Select account',
    direct_asset_select: 'Please select an asset to sell and buy',
    please_select_asset: 'Please select an asset.',
    basic_rate: 'Current price',
    direct_transfer_buy: 'On purchase immediately',
    direct_transfer_sell: 'On sale immediatel',
    direct_source_amount: 'Quantity of exchange',
    direct_target_amount: 'Applied quantity',
    direct_asset_buy: 'Buy with {0}',
    direct_asset_sell: 'Sell as {0}',
    selected_deal_info: 'Selected sales info',
    deal_source_asset_title: 'Purchase asset',
    deal_total_source_amount: 'Total Sales Quantity',
    app_info_input: 'Enter purchase info',
    app_amount: 'Purchase quantity',
    app_deal_price: 'Price per unit',
    pay_target_amount: 'Quantity to pay',
    fee: 'Fee',
    fee_calc: 'Fee amount',
    msg_fee_calc: 'Deducted by {0}',
    app_account: 'Account for Purchase Registration',
    app_receive_account: 'Choose account to receive',
    c2c_buy_select_asset:
      'Please select the sales disclosure to purchase at the main',
    go_home: 'Go back to main',
    buy_calc_spread: 'Purchase exchange rate',
    sell_calc_spread: 'The `sell rate`',
    cs_market_asset: 'Asset pair',
    cs_market_basic_rate: 'Baseline rate of sale',
    transfer_type: 'Currency type',
    exchange_rate: 'Applied exchange rate',
    submit_transfer: 'Immediate exchange',
    deal_source_min_amount: 'Minimum Purchase Quantity',
    closed_date: 'Closed date',
    no_deal: 'No sales list',
    app_price_per_quantity: 'Price per quantity',
    app_fee_amount: 'Sum total',
    select_deal_app_list: 'Purchases for selected sales',
    no_select_deal_app_list: 'No purchase history for this sale',
    transfer_source_amount: 'Reference asset quantity',
    transfer_target_amount: 'Relative asset quantity',
    transfer_basic_rate: 'Applying rate',
    transfer_spread_rate: 'Apply spread rate',
    transfer_exchange_rate: 'Applicable Exchange Rate',
    transfer_list_detail: 'Currency exchange details',
    transfer_source_asset: 'Reference assets',
    transfer_target_asset: 'Relative assets',
    transfer_source_account_number: 'Reference asset account number',
    transfer_target_account_number: 'Relative Asset Account Number',
    transfer_detail_type: 'Apply rate',
    transfer_regdate: 'Details of exchange request details',
    transfer_asset_info: 'Reference asset',
    transfer_asset_select: 'Please select an asset to replace.',
    msg_transfer_buy: 'Buy with {0}',
    msg_transfer_sell: 'Sell as {0}',
    deal_fee_amount: 'Sale Disclosure party imposed fees',
  },
  wallet_page: {
    total_amount: 'Total withdrawal',
    have_asset: 'Holding assets',
    asset_list: 'Asset list',
    account_list: 'Account list',
    account_create: 'Open account',
    deposit: 'Deposit',
    withdraw: 'Withdrawal',
    deposit_list_look: 'View deposit history',
    deposit_look: 'Deposit lookup',
    withdraw_list_look: 'Withdrawal history lookup',
    withdraw_look: 'Withdrawal lookup',
    account_modify: 'Edit account',
    deposit_apply: 'Apply for deposit',
    withdraw_apply: 'Withdrawal',
    deposit_request_amount: 'The deposit amount',
    withdraw_request_amount: 'Withdrawal amount',
    withdraw_account_info: 'Withdrawal account information',
    holder_name: 'The name of the holder',
    bank_name: 'Bank name',
    withdraw_bank_address: 'Account number',
    withdraw_address: 'Asset address',
    qr_address: 'Account address',
    create_qr_address: 'Open Account Address',
    account_enroll: 'Account Registration',
    account_seq: 'Account unique number',
    account_title: 'Account name',
    account_msg: 'Please enter your account name to change.',
    regdate: 'Opening date',
    before_regdate: '(before opening)',
    holding_balance: 'Hold amount',
    select_asset: 'Select asset',
    create: 'Open',
    deposit_list: 'Deposit history',
    no_deposit_list: 'There is no deposit request.',
    deposit_apply_detail: 'Detailed Deposit Details',
    asset_title: 'Asset name',
    request_amount: 'Request amount',
    withdraw_list: 'Withdrawal history',
    no_withdraw_list: 'There is no withdrawal request.',
    withdraw_apply_detail: 'Detailed Application Details',
    withdraw_fee_total_amount: 'Total withdrawal (including fees)',
    net_amount: 'Final amount',
    fee_type: 'Fee type',
    create_account_address: 'Account Opening Address',
    deposit_msg: 'Deposit my wallet {0} {0} from the outside of the wallet.',
    deposit_msg_1:
      'Once approved 350 times (confirmation) on the block chain {0} transactions are reflected in the wallet.',
    deposit_step_1: 'STEP 1. Check the ID {0} memos first.',
    deposit_step_1_1: 'My notes ID {0}',
    deposit_step_1_2:
      '{0} must mark your own notes ID when you deposit. {0}, with no transfer notes ID is lost.',
    deposit_step_1_3: 'View your {0} Wallet address.',
    deposit_step_1_btn: 'Notes ID Copy',
    deposit_step_2: 'STEP 2. Check your wallet address.',
    deposit_step_2_1: 'QR code',
    deposit_step_2_2: 'Wallet Address',
    deposit_step_2_3:
      'The minimum deposit amount is <span style = "color: # 4a90e2"> {0} {1} is </ span>.',
    deposit_step_2_btn: 'Purse Copy Address',
    deposit_msg_2: 'Please check',
    deposit_msg_2_1: 'This address is the address for deposit only.',
    deposit_msg_2_2:
      'The total time it takes to conform completion may be affected by the congestion of the block chain network, cryptocurrency stars Block Chaining congestion is <span style = "color: #4a90e2; cursor: pointer;"> here </span> you can check.',
    no_account_list: 'There is no account list.',
    no_favorite_account_list: 'There is no favorite account list.',
    enter_wallet_adress: 'Enter wallet address',
  },
  my_page: {
    profile: 'Member information',
    user_name: 'User name',
    email_address: 'Email',
    register_regdate: 'Subscription date',
    last_login: 'Latest login',
    auth_complete: 'Authentication completed',
    not_auth: 'Uncertified',
    expdate: 'Expiration date',
    act_auth: 'Authenticate',
    realname_auth: 'Person authentication',
    email_auth: 'Email authentication',
    otp_auth: 'OTP authentication',
    enroll: 'Enroll',
    security: 'Security level',
    show_security: 'Show security level',
    auth_withdraw_address: 'Withdrawal address authentication',
    apply_list: 'Application history',
    password_modify: 'Modify password',
    email_modify: 'Modify email',
    account_block: 'Leave Account',
    placeholder_old_password: 'Please enter your existing password',
    placeholder_new_password: 'Please enter a new password',
    placeholder_confirm: 'Please enter one more time',
    placeholder_password: 'Please enter your password',
    placeholder_email: 'Please enter a new email',
    mail_cert_list: 'Email application History',
    no_mail_list: 'No email application history.',
  },
  kyc: {
    str_birth: 'Date of Birth',
    enter_adress: 'Please enter the asset address.',
    register_account: 'Register account',
    kyc_enroll: 'Apply for KYC Certification',
    auth: 'Authentication',
    auth_code_send: 'Send verification code',
    auth_code: 'Authentication code',
    msg_auth_code: 'Please enter your verification code within 5 minutes',
    type_title: 'Type name',
    withdraw_auth: 'Authenticate withdrawal address',
    select_asset: 'Select assets',
    select_bank: 'Select bank',
    holder_name: 'The name of the holder',
    birth: '6 digits of birth',
    address: 'Asset address',
    withdraw_list: 'Withdrawal account application',
    bank_name: 'Bank name',
    withdraw_info: 'Withdrawal account information',
    withdraw_complete: 'The asset is already verified',
    regdate: 'Registration date',
    delete_withdraw_address: 'Changed debit address',
    delete_success_address: 'The withdrawal address has changed.',
    kyc_cert_list: 'KYC Application History',
    no_kyc_list: 'KYC is no application history.',
    no_kyc_withdraw_address_list:
      'There is no payment account application history.',
  },
  otp: {
    enter_verification_number: 'Enter your OTP verification number',
    otp_auth: 'OTP authentication',
    authenticode: 'OTP key',
    otp_deactivate: 'OTP deactivate',
    msg_authenticator_installation:
      'Please install the" Google Authenticator "app on your smartphone or desktop',
    android: 'Android ',
    or: 'Or ',
    iphone_series: 'IPhone、iPad、and iPod',
    windows_phone: ' Windows Phone',
    and: 'And',
    msg_microsoft_other_systems: 'Microsoft Windows desktop',
    msg_key: 'This key ',
    msg_use_loss_change:
      ' Write on paper Used when you lose your device or need to change your OTP. ',
    msg_brcode_touch:
      'Run the "Google Authenticator" app and tap <b> Scan QR barcode </ b> at the bottom of the screen',
    msg_input_authenticode:
      '"Please enter the verification code displayed on your device`s screen in the" Authorization Code "field below',
    otp_key: 'OTP key',
    otp_activate: 'OTPactivate',
    otp_copy: 'OTP key copied',
    otp_safe_keeping:
      'Did you write the OTP key on paper and store it in a safe place?',
    yes: 'Yes',
    otp_register: 'Register',
    otp_register_success: 'OTP registration completed successfully.',
    otp_delete_success: 'OTP Erase Registration completed successfully.',
    msg_click_key_copy: 'Click to copy the key',
    otp_login: 'OTP login',
  },
  security: {
    show_security: 'Show security level',
    grade: 'Grade',
    condition: 'Condition',
    restriction: 'Restriction',
    no_grade: 'Unrated',
    no: 'None',
    security_title: 'Constraints by Condition of Security',
    banner1: 'Trusted Security',
    banner2:
      'For the purchase or sale through ONEWORLDPAY, ONEWORLDPAY must secure data encryption, real-time transaction monitoring, the buyer and seller protection policy, and all your payments through a secure checkout and payment scheme received ONEWORLDPAY.',
    banner_invite: 'ONEWORLDPAY Do not have an account?',
    banner_join: 'Free Sign Up',
    banner3: 'How ONEWORLDPAY is keeping our customers safe',
    content1_h3: 'Buyer Protection',
    content1_text:
      'If the buyer ohbaesong wear or damage mibaesong, ONEWORLDPAY can compensate for the total payment amount, including shipping costs for eligible transactions. *',
    content2_h3: 'Seller Protection',
    content2_text:
      'If you receive an unauthorized payment or mibaesong claims against the seller in the sale are eligible, you can get the full amount of protection. *',
    content3_h3: 'Data Encryption',
    content3_text:
      'TLS, HTTPS connections to help keep the payment, the key pinning of mobile apps, PCI compliance more secure.',
    content3_btn: 'PCI Compliance',
    content4_h3: 'Fraud Prevention',
    content4_text:
      'All transactions are monitored in real time by analyzing your account and support to prevent fraudulent activity and billing.',
    sec_h2: 'Check Buy',
    sec_text:
      'ONEWORLDPAY because the transaction monitoring 24 hours a day, 365 days when it detects something different from usual to contact the buyer asks you to confirm your login or purchase. Also ONEWORLDPAY checks for all purchases and sales via e-mail.',
    wran_h2: 'If you find a suspicious points',
    warn_step1: 'Report.',
    warn_step1_text1:
      'After you confirm the details have not found a deal approved',
    warn_step1_text2: 'Report a problem> unauthorized activity report',
    warn_step1_text3: 'Click or contact immediately ONEWORLDPAY.',
    warn_step2: 'Check if there are other problems.',
    warn_step2_text1:
      'Review recent trading activity and account settings to make sure that the additional charges or changes, please also report this information.',
    warn_step3: 'Please change your password.',
    warn_step3_text1:
      "You can in the account settings on the Security menu. Or, if you're unable to sign in to your account",
    warn_step3_text2: 'Login> Problems logging',
    warn_step3_text3: 'Click to get reset.',
    warn_btn: 'Report unauthorized transactions',
    online_h2: 'ONEWORLDPAY supports Secure online activities.',
    online_h3: 'Account Security',
    online_text: 'Protect your account with a highly secure password.',
    online_btn: 'Learn more',
  },
  input: {
    id: 'Input ID',
    password: 'Input a password (8-32 digits with special characters)',
    repeat_password: 'Confirm Password',
    user_name: 'Input Username',
    email_address: 'Input E-mail address',
  },
  oauth: {
    contact_msg:
      'Wants access to the following information in the application {0}.',
    agree_msg: '{0} Do you agree that access to {1} `s personal information?',
    agree_info:
      'The information provided will be utilized / stored for a period of service for the user identification, statistics, accounts linked CS and the like. Basic information and provide the required items is the information that must be provided to use the ONEWORLDPAY services.',
    agree_request: 'Offerings',
    agree_msg2:
      'Once agreed, the information will be managed in accordance with the Terms and Conditions and Privacy Policy of the service.',
    agree: 'To agree',
  },
  pay_head_foot: {
    account_management: 'Account management',
    settlement_account_list: 'Settlement Account List',
    account_summary_views: 'Account Summary Views',
    fund: 'funds',
    history: 'Payment history',
    help: 'Help',
    qa: 'Contact Us',
    fee: 'fees',
    secure: 'security',
    go_shop: 'Shopping',
    my_info: 'My profile',
    my_page: 'Account Settings',
    out: 'Log out',
    in: 'login',
    about: 'About Us',
    blog: 'blog',
    employ: 'Jobs',
    site_map: 'site map',
    developer: 'developer',
    partner: 'partner',
    privacy_state: 'Privacy Statement',
    usage: 'Terms of Use',
    feed_back: 'feedback',
    warn_to_consumer:
      'Notification to customers: the owners of prepaid means of payment ONEWORLDPAY ⓒ ONEWORLDPAY All rights reserved does not require the approval of the Australian Financial Supervisory Authority. Please read carefully the terms and conditions.',
  },
  continue: 'continue',
  pay_home: {
    cocobank_title: 'COCO Bank',
    platform: 'platform',
    platform_rental: 'Renting platforms',
    cocopay_is: 'ONEWORLDPAY is the growth of the business',
    help: 'Helping.',
    home_banner_1:
      'Expanding the potential customer base around the world, and to facilitate payment management,',
    home_banner_2:
      'Business Seller Protection *, and allow safe to shop with 24/7 fraud monitoring.',
    home_banner_3: 'You can more easily succeed.',
    home_banner_warn:
      '* Terms and Conditions apply to the protection seller. Please refer to your contract for details on eligibility.',
    home_banner_join: 'Join now for free.',
    home_sec1_openShop: 'You can open a store in ONEWORLDPAY.',
    home_sec1_btn: 'To deal',
    home_sec2_h2: 'Get the desired payment method.',
    home_sec2_text1:
      'ONEWORLDPAY can also receive payments online, mobile, and even email.',
    home_sec2_text2:
      'Whether the ONEWORLDPAY sold anywhere who can assist with easier and more secure payment.',
    home_sec2_online_pay: 'Online Payment',
    home_sec2_online_text:
      'Payment buttons for easy set available ONEWORLDPAY is very handy when receiving cash payments and periodic payments, donations, etc. With ONEWORLDPAY Checkout, customers can make payments more quickly and easily.',
    home_sec2_online_more: 'See more about online payment',
    home_sec2_voice_invoice: 'Email Invoice',
    home_sec2_voice_text:
      'Easy e-mail request for payment to the professional free the invoice. Overseas customers as well as are available to customers who are not ONEWORLDPAY account.',
    home_sec2_voice_more: 'See more about email invoices',
    home_sec2_exchange_pay: 'Make a payment on the exchange',
    home_sec2_exchange_text:
      'With the integrated wallet service on the exchange, you can recharge and buy and sell coins on any exchange of partner companies.',
    home_sec2_exchange_more: 'Learn more about exchange charging',
    home_sec2_mobile_pay: 'Get mobile payments',
    home_sec2_mobile_text:
      'Solutions are automatically optimized for mobile. Get world where even easier to pay through the mobile website or the Android and iOS apps.',
    home_sec2_mobile_more: 'See more about mobile payments',
    home_sec3_h2: 'Find more work with ONEWORLDPAY freelance partners.',
    home_sec3_global:
      "ONEWORLDPAY will connect the more global opportunities with the world's top freelance sites.",
    home_sec3_btn: 'Checking ONEWORLDPAY for freelance',
    home_sec4_h2: "It's easy to get started.",
    home_sec4_banner1:
      'Learn everything you need to start from ONEWORLDPAY business hub.',
    home_sec4_banner2:
      'Join the business account and verify your email address',
    home_sec4_banner3: 'Certified to the bank account',
    home_sec4_banner4: 'Select a payment solution',
    home_sec5_h2: 'Why the world many operators do trust ONEWORLDPAY.',
    home_sec5_sub_text:
      'Because it is an excellent choice. ONEWORLDPAY you like to connect the seller with 25 calls to the customer at least two one hundred million people in more than 200 markets worldwide.',
    home_sec5_h3: 'Safety.',
    home_sec5_h3_sub1:
      'Automatically determining scam, 24-hour monitoring transactions and the seller and buyer protection program to protect your business and your customers.',
    home_sec5_h3_more: 'See more about online payment',
    home_sec5_h31: 'The world uses.',
    home_sec5_h31_sub1:
      'All over the world without the need to enter the information each time you make a payment quickly. In 203 markets in 26 currencies you can pay via credit card, debit card or ONEWORLDPAY.',
    home_sec5_h31_more: 'See more about email invoices',
    home_sec5_h32: 'Fast.',
    home_sec5_h32_sub1:
      'In most cases when a customer payment is immediately credited to your account ONEWORLDPAY. Debited bank or a payment to the vendor or use freely in any place where ONEWORLDPAY payment possible.',
    home_sec5_h32_more: 'See more about eBay selling',
    home_sec6_h2: 'Simple fee structure',
    home_sec6_sub:
      "ONEWORLDPAY will charge a fee only when the sales made. ONEWORLDPAY fees are fixed based on the customer's location and the amount of sales.",
    home_sec6_more: 'See more about fees',
    home_sec7_h2: 'Community for South Korea selling, CBT LAB',
    home_sec7_text1:
      'Cross-Border Trade Institute (CBT LAB) is a ONEWORLDPAY Korea (ONEWORLDPAY Korea) merchant community sponsored for overseas e-commerce enabled.',
    home_sec7_text2:
      'CBT LAB is helping the East Coast business grow globally share information such as the latest trends, tips, and best practices.',
    home_sec7_more: 'Learn how to take advantage of CBT LAB',
    home_sec8_h2: 'Meet the partners interlocking ONEWORLDPAY.',
    home_sec8_text1: 'Need professional help for your online business?',
    home_sec8_text2:
      'Web hosting solutions, shopping cart, e-commerce solutions, such as advance works ONEWORLDPAY a partner bought this help your business.',
    home_sec8_text3: 'Find ONEWORLDPAY a partner for my business right now.',
    home_sec8_more: 'More Partners',
    home_sec9_h2: 'Become a global seller. This will ONEWORLDPAY together.',
    home_sec9_btn: 'Sign up for an account now',
    home_learn_h2: 'Learn more',
    home_learn_li1: 'Web Payment Solution',
    home_learn_li1_1: 'Website Payments Standard',
    home_learn_li1_2: 'ONEWORLDPAY Checkout',
    home_learn_li1_3: 'Buy on eBay',
    home_learn_li1_4: 'Compare Solutions',
    home_learn_li2: 'Other payments',
    home_learn_li2_1: 'ONEWORLDPAY email invoices',
    home_learn_li2_2: 'Mobile Commerce',
    home_learn_li2_3: 'Business for automatic payments',
    home_learn_li2_4: 'ONEWORLDPAY for B2B',
    home_learn_li2_5: 'ONEWORLDPAY for freelance',
    home_learn_li3: 'ONEWORLDPAY setup and integration',
    home_learn_li3_1: 'ONEWORLDPAY business hub',
    home_learn_li3_2: 'ONEWORLDPAY Korea merchant community (CBT LAB)',
    home_learn_li3_3: 'Add ONEWORLDPAY ONEWORLDPAY to the site',
    home_learn_li3_4: 'Check out Best Guide Set',
    home_learn_li3_5: 'developer',
    home_learn_li3_6: 'partner',
    home_learn_li3_7: 'How ONEWORLDPAY',
    home_learn_li4: 'Manage My Account',
    home_learn_li4_1: 'ONEWORLDPAY business apps',
    home_learn_li4_2: 'Business Account Settings',
    home_learn_li4_3: 'Seller Protection Program',
    home_learn_li4_4: 'Manage customer complaints',
    home_learn_li4_5: 'Understanding Chargebacks (Chargeback)',
    home_learn_li4_6: 'Understanding account restrictions',
    home_learn_li4_7: 'Fraud Prevention Tips',
    home_learn_li4_8: 'PCI Compliance',
  },
  pay_nav: {
    view_your_account: 'View your account',
    account_summary_views: 'Account summary views',
  },
  pay_login: {
    cocopay_is: 'ONEWORLDPAY is the growth of the business',
    secure_sub_title: 'Login and Security',
    secure_my_profile: 'My profile',
    secure_update_complete:
      'The environmental profile and settings have been updated.',
    secrue_suggest: 'Whenever you tell us your experience.',
    search: 'Search',
    my_info: 'Privacy',
    update: 'update',
    e_mail: 'e-mail',
    default: 'Basic information',
    call: 'telephone',
    phone: '(cellphone)',
    pay_mobile: 'mobile pay',
    trading: 'Give-and-take',
    password: 'password',
    change: 'change',
    secure_qa: 'Security Question',
    staying: 'Keep me logged in for faster purchases',
    edit: 'edit',
    browse_manage:
      'Manage the selected device and the browser to maintain login state.',
    account_type: 'Account Types',
    account_delete: 'Account Cancellation',
    business: 'business',
    edit_email: 'Edit email address',
    change_email: 'Change Email Address',
    update_email: 'Add your email',
    eamil_url: 'Email Address',
    update_email_url: 'Add your email address',
    error_email: 'Sorry. The default e-mail can not be edited.',
    confirm_new_email: 'Check for new e-mail address',
    change_mail: 'Change email',
    confirm: 'Confirm',
    changing: 'change',
    deleting: 'delete',
    reaming:
      'There are currently two of the email address associated with your account. You can add more to 5 email.',
    qa_1: 'What is the name of the first attended school?',
    qa_2: 'What is the name of first pet?',
    edit_phone: 'Edit an existing phone number',
    korea: 'Republic of Korea',
    explanation:
      'By adding the number, I confirm that you agree to automatically dial and receive pre-recorded calls and text depending on the reason for the authority to add two numbers are described in the Privacy Policy. Standard rates may apply.',
    edit_phone_num: 'Change phone number',
    edit_password: 'Change Password',
    confirm_password: 'Check your current password',
    new_passod: 'New password',
    confirm_password_new: 'New password confirmation',
    secure_question: 'Security Question',
    secure_pick: 'Choice questions',
    secure_answer: 'answer',
    edit_browse:
      'With ONEWORLDPAY One Touch you can quickly complete the payment without having to log in each time.',
    already_log: 'The logged on the machine.',
    off_all: 'ONEWORLDPAY One Touch off on all your devices',
    support:
      'PayPal is committed to 100% customer satisfaction. If you have a problem with your account',
    support_center: 'Customer Support',
    support_text1: 'Or check the',
    support_text2: 'Please refer to.',
    support_warn:
      'If you cancel your account, you can not cancel your account records will also disappear and reliability levels.',
  },
  help: {
    support_center: 'Support',
    resolution_center: 'Dispute Resolution Center',
    qa_search: 'Search Frequently Asked Questions',
    common_qa: 'General questions',
    common_qa_1:
      "What `Why is an error message is displayed after updating the status of your order via the 'Get Links funds?",
    common_qa_2: 'How do I withdraw funds from Korea ONEWORLDPAY account?',
    common_qa_3:
      'How do I add a debit or credit card to my account ONEWORLDPAY?',
    common_qa_4:
      'ONEWORLDPAY I forgot my account password. How do I reset my password?',
    common_qa_5: 'Can I cancel already sent payment amount ONEWORLDPAY?',
    common_qa_6: 'How do I receive payments through ONEWORLDPAY?',
    common_qa_7: 'How do I send the Payment via ONEWORLDPAY?',
    common_qa_8: 'How do I add a bank account to ONEWORLDPAY account?',
    common_qa_9:
      'How can I check the bank account associated with my account ONEWORLDPAY?',
    common_qa_10: 'How do I disable the account ONEWORLDPAY limit?',
    technical_support: 'Subscribe to technical issues and updates.',
    condition_cocopay: 'View ONEWORLDPAY state',
    muliple_help: 'More ways to get help',
    trading_help: 'To solve such problems deal',
    tex_center: 'Tax Center',
    tex_help: 'Find tax forms and other resources',
    need_help: 'Contact Us',
    help_center: 'Contact Customer Support',
    help_to_center: 'Contact Customer Support',
    prepare: 'Coming soon.',
    fast_help:
      'Tell us your problem so that we can more quickly help ONEWORLDPAY.',
    my_search: 'Search for My Problem',
    common_problem: 'Common Problems',
    login_problem: 'Login issues',
    unkown_charge: 'Unauthorized access or unknown claims report',
    send_money: 'Send money',
    get_fund: 'Receiving money',
    withdraw_money: 'Withdraw money',
    pay_cancel: 'Payment or cancel order',
    pay_hold: 'Payment pending or waiting',
    refund: 'refund',
    pre_pament: 'Pre-approved payments',
    negative_balance: 'Negative balance',
    account_qa_1:
      'ONEWORLDPAY withdraw from my account the state though it shows as "completed" Why is money that does not contain a bank account?',
    account_qa_2:
      'What is the reason for my withdrawal ONEWORLDPAY is still a "pending" status?',
    account_qa_3: 'Why was my withdrawal pending?',
    item_title: 'Access Password and Account',
    item_title_2: 'Account Profile & Settings',
  },
  business: {
    no_trade: 'There is no possible exchange markets.',
    view_your_account: 'View your entire account',
    available: 'Available',
    calculate_late: 'Recently estimated amount based on the exchange rate.',
    payment_transfe: 'Payment transfers',
    exchange: 'exchange',
    currency_update: 'Add call',
    update_btn: 'Plus button',
    currency_cal: 'Currency converter',
    pay_default: 'Payment Preferences',
    payment_send: 'Send or request Payment',
    account_list: 'Account List',
    no_alias: 'No aliases',
    new_bank: 'Connect the new bank',
    card: 'Card',
    new_card: 'Connect the new card',
    credit: 'credit',
    preference_payment: 'Choose your preferred online payment methods.',
    payment_tip:
      'When shopping online or sending Payment for goods and services using this means. You may at any time choose a different payment method during checkout.',
    payment_more: 'Learn about your payment preferences',
    paymnet_changes: 'ONEWORLDPAY balance',
    debit_card: 'Debit Card',
    currency_tip:
      'If you add a currency, all future payments received in that currency will be credited to the appropriate funds. The base currency is used to send a payment or request payment.',
    currency_1: 'Australian Dollar',
    currency_2: 'Swiss Franc',
    currency_3: 'Czech Koruna',
    currency_4: 'Danish Krone',
    currency_5: 'Euro',
    currency_6: 'British Pound',
    currency_7: 'Hong Kong Dollar',
    currency_8: 'Forint',
    currency_9: 'Israeli New Shekel',
    currency_10: 'Mexican Peso',
    currency_11: 'Norway Krone',
    currency_12: 'New Zealand dollar',
    currency_13: 'Philippine Peso',
    currency_14: 'Polish Zloty',
    currency_15: 'Russian Ruble',
    currency_16: 'Swedish Krona',
    currency_17: 'Singapore Dollar',
    currency_18: 'Baht',
    currency_19: 'New Taiwan Dollars',
    withdraw_account: 'Withdrawal Account',
    exchanged: 'After currency exchange',
    exchange_rate: 'Exchange Rate',
    exchange_tip:
      'The exchange rate is an estimated amount based on the current exchange rate, the exchange fee is included in the ONEWORLDPAY.',
    currency_default: '(A) The Japanese Yen is set to the default currency.',
    currency_default_notice:
      'The base currency is used to send a payment or request payment.',
    currency_default_notice2:
      'Closing the call is not displayed on the balance does not receive any payment to the call.',
    currency_default2: 'JPY (s), the default',
    currency_quit_jp_btn: 'Close Dollars',
    currency_quit_btn: 'Close call',
    bank_account: 'account',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'balance',
    bank_account_check: 'Confirming Bank',
    bank_account_remove: 'Delete Bank',
    bank_continue: 'Would you like to continue?',
    bank_tip:
      'Pending transactions with the banks are processed after deletion.',
    bank_this_delete: 'Delete Bank',
    card_tip:
      'The ONEWORLDPAY account Want to use it without spending or withdrawal limits?',
    card_confirm: 'Check the card.',
    card_type: 'type',
    expiry_date: 'Expiration',
    card_adress: 'Billing Address',
    card_update: 'Card Update',
    card_delete: 'Delete card',
    card_this_delete: 'Delete card',
    card_tip2:
      'This payment method is currently preferred. Upon completion, you can set a different preferred payment method. Deal is pending with (a) undefined is treated after the deletion.',
    secure_code: 'Security Code',
  },
  shop: {
    shop_list: 'Store List',
    shop_create: 'Shop created',
    shop_cre_date: 'Added',
    shop_title: 'Store name',
    shop_id: 'Store ID',
    shop_state: 'state',
    shop_work: 'work',
    shop_detail: 'Detail',
    shop_retouch: 'Modify',
    shop_settlement: 'Settlement accounts list',
    no_shop_history: 'There is no transaction history.',
    shop_history: 'Transactions',
    no_shop_list: 'There is no list of stores',
  },
  merchant: {
    create: 'Shop registration',
    update: 'registration',
    retouch: 'Shops modified',
  },
  pay_legal: {
    service_usage: 'ONEWORLDPAY Terms of Service',
    detail_usage:
      'These Terms and Conditions will apply to the Asia-Pacific, Latin America and some European countries, Middle East and African users. To view the terms and conditions for different countries or regions, choose from the list below.',
    nation: 'Select a Country',
    every_consumer: 'All users',
    service_agree: 'Your contract for the Service ONEWORLDPAY',
    privacy_state: 'Privacy Statement',
    purpose_policy: 'ONEWORLDPAY Use Policy',
    payment_agreement: 'ONEWORLDPAY alternative payment method agreement',
    sell_buy: 'Merchant and Business',
    shop_policy: 'ONEWORLDPAY Support Store Policies',
    contract_profit: 'Contract for-profit corporation',
    billing_agreement: 'Billing Agreement',
    direct_debit_agreement: 'ONEWORLDPAY funds received and debit agreements',
    additional_info: 'Additional Information',
    infringement: 'Somyeongseo policy violations',
    policy_update: 'Policy Updates',
    warn1:
      'Notify Consumers: ONEWORLDPAY payment service is regarded as a prepaid means of payment (Stored Value Facility) in accordance with Australian law.',
    warn2:
      'ONEWORLDPAY the owners of prepaid means of payment ⓒ ONEWORLDPAY All rights reserved does not require the approval of the Australian Financial Supervisory Authority. We also encourage consumers (users) are carefully read these Terms and Conditions.',
    warn3:
      'These Terms of Use and Notices provide the terms and conditions associated with a particular ONEWORLDPAY services.',
  },
  pay_privacy: {
    effective_day: 'Effective Date: 28 March 2019',
    summary: 'summary',
    personal_data: 'Personal data collected by ONEWORLDPAY',
    personal_date_cause: 'Reasons to keep your personal data ONEWORLDPAY',
    summary_1: 'Our users are',
    summary_2: 'site',
    summary_3: 'Or visit',
    summary_4: 'service',
    summary_5: "When using the user's",
    summary_6: 'Personal data',
    summary_7:
      'How to collect and store, manage, and share, explaining that the transfer has prepared this Privacy Policy. This Privacy Policy applies to your personal data when visiting our site or use the service, other ONEWORLDPAY',
    summary_8: 'user',
    summary_9:
      'It does not apply to websites or online web ONEWORLDPAY not owned or adjustments, including service site or service.',
    summary2_1:
      'ONEWORLDPAY can you visit our sites or collect personal information when you use the following types of services.',
    summary2_2: 'Use Up and Information',
    summary2_3:
      'When you sign up an account to use the services of ONEWORLDPAY, to meet the information necessary to collect personal data in order to provide the service requested by the user.',
    summary2_4:
      'Depending on the services selected, you can ask to provide the identification information required to create a user name, mailing address, telephone number, email address, account.',
    summary2_5:
      'Terms you may ask to provide additional personal data, depending on the service.',
    summary3_1: 'Trading experience and information',
    summary3_2:
      'Using the services of ONEWORLDPAY or if access to the site, for example, buy from the seller, or receipt of money or if processing a payment or send money to friends and family, collect other trading related information, as well as transaction information from ONEWORLDPAY The. Other trade-related information includes the sending or requesting money, goods or money payment service, the seller, including information about all the payment methods used to complete the transaction information and device information, technology data, location information, and the like.',
    summary4_1: 'Participant Information',
    summary4_2:
      'When you use or access the site ONEWORLDPAY service collects personal data that users provide about other participants involved in the deal.',
    summary4_3: 'To send or request money',
    summary4_4:
      'If you send or request money through the Service ONEWORLDPAY collect your name, mailing address, telephone number, personal data such as receive money from your financial account information of the participant sending the money to you.',
    summary4_5:
      'The scope of personal data requested in relation to the participants may vary depending on the service used to send or request money.',
    summary5_1:
      'Payment for other people instead of bills or bill requesting payment to another person',
    summary5_2:
      'If you use ONEWORLDPAY service to ask them to pay the bill on behalf of another person, or pay your bills on their behalf to another user, the user name, mailing address, telephone number, email address, user billing instead of bills or others the account owner must collect relevant personal data, including account number you want to pay instead.',
    summary6_1: 'Add money to your account',
    summary6_1_1: 'Your account',
    summary6_2:
      "In order to add money to other accounts in the user's account or the user may own, or if you use ONEWORLDPAY service to request to be added to the amount in this account to the other users on the other side from the user to efficiently process your request gather information or may collect information about you from the other side.",
    summary6_3:
      'For example, charging or using the services ONEWORLDPAY request to be added to the amount in the account to a mobile phone, you can collect other information, including personal data, and mobile account number from the other participants.',
    summary7_1:
      'Information relating to the person on your friends and contacts',
    summary7_2:
      "When the user connects the contact list in your account, it's easier to give help people deal with when ONEWORLDPAY with your friends and contacts. So that the user can use the device, or set up a connection between social media platforms or devices to ONEWORLDPAY accounts or social media when connected to the platform better ONEWORLDPAY services collect and use your contacts list information (name, address, email address, etc.) in ONEWORLDPAY improve the environment.",
    summary8_1:
      'The information you choose to provide ONEWORLDPAY in order to use certain online services or additional services',
    summary8_2:
      'If the request or participate in the selection of the site to request features or improved services, or other optional features, you can collect additional information about users in ONEWORLDPAY.',
    summary8_3:
      'If the methods used to collect information from those services differ from those stated in this Privacy Policy, the information collected during a separate notice.',
    summary9_1:
      'Information for the user when using the "ONEWORLDPAY non-payment" service',
    summary9_2:
      'For some limited services may need to sign in or use your account settings to non-payment. ONEWORLDPAY will collect your personal data, all payment methods relevant device information, technology data, location information necessary for the user to complete the transaction. When you select the account owner and the payment for the non-trading, you can build and collect transaction information associated with your account.',
    summary9_3:
      'If the user while not the account owner and select the payment for the non-ONEWORLDPAY deal, collect and store all information you provide is used and shared in accordance with the information in this Privacy Policy.',
    summary10_1: 'User-specific information obtained from third parties',
    summary10_2:
      'From a third party, such as merchant, data providers, credit bureaus to the extent permitted by law, you can get the information.',
  },
  partner: {
    be_partner: 'Become a partner of ONEWORLDPAY.',
    banner_text:
      'Shopping platform provider, marketplace, there is a billing support operators that require a payment service provider can be a partner of ONEWORLDPAY.',
    banner_btn: 'To contact your account manager',
    benefit: 'ONEWORLDPAY benefits that partners are entitled',
    benefit_1: 'Integration and technical support for building solutions',
    benefit_2:
      'Please feel free to contact our support team for you to get help in ONEWORLDPAY integration. ONEWORLDPAY developer portal can also be used as a resource.',
    benefit_3: 'Business growth through marketing opportunities',
    benefit_4:
      'Take advantage of the many marketing opportunities provided ONEWORLDPAY can attract potential customers.',
    traction: 'And towing payments around the world.',
    traction1:
      'ONEWORLDPAY partners are supporting an innovative platform for a smooth settlement of sellers to trust ONEWORLDPAY.',
    traction_btn: 'More Partners',
    program: 'ONEWORLDPAY Partner Program is free to join.',
    program_1:
      'Please fill out the online form, we will contact you in ONEWORLDPAY.',
    program_2:
      'Please describe the operational and running business solutions.',
    program_3: 'Please contact ONEWORLDPAY to discuss the necessary changes.',
    program_4:
      'ONEWORLDPAY integrate with and help ensure that they receive payment ONEWORLDPAY.',
    program_btn: 'To contact your account manager',
    common_qa: 'Frequently Asked Questions',
    common_qa1: 'Is there any vendors ONEWORLDPAY partner?',
    common_qa1_text:
      'ONEWORLDPAY partner is the B2B (business-to-business) company that offers its customers solutions ONEWORLDPAY. ONEWORLDPAY is working with organizations such as the shopping cart, web hosting companies, web developers, logistics providers, and digital marketing agency, payment gateway.',
    common_qa2: 'What ONEWORLDPAY partners eligible?',
    common_qa2_text: 'Contact your account manager',
    common_qa2_text_2:
      'You can get advice about the qualifications of the partners.',
    common_qa3: 'We provide integrated support services in the ONEWORLDPAY?',
    common_qa3_text:
      'Once registered in the partner program and ONEWORLDPAY approval to join, you can access the valuable integrated documentation and developer forums. It can also get integrated support for consultants for the certificate.',
    common_qa4:
      'There is also a business outside of Korea, can I sign up separately for each country in the Partner Program?',
    common_qa4_text:
      'It depends on the country you are operating a business. In ONEWORLDPAY are deploying specialized partner representative to the regional requirements in various countries.',
    common_qa4_more: 'View Partner Program provides national',
  },
  pay_main: {
    total_product: 'Total product',
    total_sum: 'sum',
    pay_this_account: 'Set this account as a payment method.',
    bill_show:
      'The transaction information is displayed as follows in the specification.',
    banner_text: 'ONEWORLDPAY is more secure',
    banner_text2: 'A quick payment.',
    banner_text3:
      'No matter where shopping will keep your financial information secure.',
    footer_1: 'terms',
    footer_2: 'User Agreement',
    footer_3: 'Privacy Statement',
    footer_4: 'feedback',
    footer_5:
      'Notification to Consumers: Coco Bank Profile The owner of the prepaid payment means ⓒ Cocobank All Rights Reserved does not require the approval of the Swedish Financial Supervisory Authority.',
    footer_6: 'Terms of Use',
    footer_7: 'We also encourage you to read it carefully.',
    footer_8: 'payment',
    wallet: 'E-wallet management',
    last_name: 'castle',
    card_number: 'card number',
    three_number: 'Three digits',
    name: 'name',
    pay_cocopay: 'To pay by ONEWORLDPAY',
    free_shipping:
      'If the ONEWORLDPAY account, you can get free return shipping, purchase protection.',
    email_phone: 'Email or phone number',
    login_error: 'Do you have trouble signing in?',
    pay_card: 'Payment by card',
    cancel_back: 'Cancel and go back to the previous page',
  },
  site_map: {
    site_map_tip: 'A link that will help you explore the ONEWORLDPAY account.',
    map_fund: 'funds',
    map_fund_1: 'Debited',
    map_fund_2: 'My ability to use the balance is?',
    map_fund_3: 'Send or request money',
    map_fund_4: 'Call Management',
    map_fund_5: 'ONEWORLDPAY my debit card discounts',
    map_fund_6: 'Get ONEWORLDPAY debit card',
    map_fund_7: 'ONEWORLDPAY Credit Billing Schedule',
    map_deal: 'deal',
    map_deal_1: 'View all deals activity',
    map_deal_2: 'Activities views (including balance and fees)',
    map_deal_3: 'View Deal graphs and charts',
    map_deal_4: 'Download Deal',
    map_deal_5: 'In response to a claim or chargeback',
    map_deal_6: 'IPN (instant payment notification) History',
    map_profile: 'My Profile and Settings',
    map_profile_1: 'Business mirror',
    map_profile_2: 'Email, address, phone or password Update',
    map_profile_3: 'Bank account or card update',
    map_profile_4: 'Update Notifications',
    map_profile_5: 'View Account Limits',
    map_profile_6: 'User Management',
    map_profile_7: 'Delivery Update Preferences',
    map_support: 'support',
    map_support_1: 'Go to the Center for Conflict Resolution',
    map_support_2: 'Go to Support Center',
    map_support_3: 'Contact Us',
    map_support_4: 'ONEWORLDPAY merchant fee information',
    map_report: 'report',
    map_report_1: 'Report to set up, manage or download',
    map_manage: 'tool',
    map_manage_1: 'View tool',
    map_manage_2: 'ONEWORLDPAY button management',
    map_manage_3: 'Regular Payment Management',
    map_consum: 'customer',
    map_consum_1: 'View Guest List',
  },
  fee: {
    fee_tip: 'Simple Fee Structure',
    fee_banner_1:
      'Generally, buying is free and may be subject to currency exchange fees.',
    fee_banner_2:
      'If sales do not stick with the ONEWORLDPAY monthly fees, or cancellation fees. After each commission will only be paid.',
    fee_h2: 'Typically purchase is free.',
    fee_text1: 'Fees for processing payments are paid by the seller.',
    fee_text2: 'However, you can exchange fee is applied.',
    fee_more: 'Seller fees learn more',
    fee_text3:
      'For sale by the invoice or payment Email Web site (international payment standard rates apply)',
    fee_text4: 'A fixed fee based on the receipt of calls',
    fee_text5: 'Exchange fees may apply additionally.',
    fee_text6:
      'For example, for a fixed fee payment receipt in USD it is $ 0.30 USD.',
  },
  dash: {
    more: 'View more',
    withdraw_asset: 'Funds withdrawal',
    currency: 'currency',
    quotes: 'Invoices and Estimates',
    last_6_months: 'Last 6 Months',
    make_invoice: 'Invoice generation',
    manage_invoice: 'Invoice Management',
    grown_up: 'Please send to grow the business for a quote.',
    un_paid_invocie: 'Outstanding invoices',
    make_quotes: 'Quote generation',
    quotes_1: 'One has suggested any outstanding invoices.',
    quotes_2: 'ONEWORLDPAY invoice',
    quotes_alarm: 'Send reminders',
    quotes_detail: 'Show more',
    quotes_who: 'Bill to: Choi, So - Young',
    latest_act: 'Recent Activity',
    act: 'activity',
    received: 'Received Payment',
    send: 'From Payment',
    act_record: 'Activity (including balance and fees)',
    pay_person: 'Biller people',
    show_all: 'View all',
    tell_us: 'Please tell us your opinion.',
    feed_text:
      'Please take a moment to tell us your opinion on the newly designed display information on this page. Thank you!',
    service: 'Provide feedback',
    feed_text_back:
      'Thank you for your feedback! Was this how our site is useful?',
    feed_placeholder:
      'Please let me know the reason I came today ONEWORLDPAY there is a better way. Do not include personal information, such as email or account number.',
    feed_p:
      'ONEWORLDPAY office staff and guests to your comments can be posted internally, so you can see it, do not leave any personal information. Customer service issues, please click here. Of ONEWORLDPAY',
    feed_protect: 'Privacy Policy',
    feed_law: 'Legal Conditions',
    feed_or: 'And',
    feed_need: 'Refer to the',
    trade_name: 'Deal name',
    trade_id: 'Deal ID',
    trade_amount: 'Amount of payment',
    detail_show: 'Example',
  },
  shop_detail: {
    detail_info: 'Shop Details',
    api_signature: 'Store signing key',
    msg_shop_create: 'This shop has been registered.',
    msg_shop_modify: 'This shop has been fixed.',
  },
  merchant_account: {
    create_account: 'Generate Settlement Account',
    enroll_account: 'Registration Settlement Account',
    pls_select_account: 'Choose Settlement Account',
  },
  transaction_detail: {
    select_pay_account: 'Select payment account',
    transaction_title: 'Deal details',
    order_id: 'Shop Order Number',
    pay_account_title: 'Payment Account Name',
    pay_account_number: 'Payment Account Number',
    pay_account_balance: 'Payment Account Balance',
  },
  guide: {
    title: 'C2C trading guide',
    watch_video: 'Watch video',
  },
  account_transfer: {
    transfer: 'Bank Transfer',
    transfer_list: 'Transfer history',
    msg_required_data: 'Please enter all the values',
    msg_not_select_withdraw_account: ' Please select withdrawal account',
    create_transfer_title: 'Accounts transfer',
    from_account_select: ' Select withdrawal account',
    available_transfer: 'Transfer amounts',
    to_account_input: ' Enter transfer account number',
    to_account_confirm: 'Verify transfer account',
    to_account_user_name: 'Transfer Account Member Name',
    transfer_amount: 'Transfer Amount',
    delete_amount: 'Correction',
    all_amount: 'FULL',
    description: 'Explanation',
    transfer_btn: 'Transfer',
    transfer_btn_2: 'Transfer',
    transfer_info_check: 'Check transfer request information',
    transfer_info_check_2: 'Check transfer request information',
    from_account_number: 'Withdrawal Account Number',
    from_asset_title: 'Withdrawal Account Assets',
    to_account_number: 'Transfer Account Number',

    success_transfer: 'Transfer has been processed successfully.',
    success_withdraw: 'Withdrawal has been processed successfully.',
    transfer_list_detail: 'Transfer History',
    search_transfer_asset: 'Search by property',
    search_transfer_account: 'Search by account',
    reset: 'Reset',
    search: 'Search',
    transfer_list_detail_tit: 'Transfer Details Details',
    no_transfer: 'No transfer details',
    msg_not_search_account: 'Account number does not exist or not valid.',
    my_account_transfer: 'My account transfers',
    msg_pls_select_account: 'After selecting an asset, search the account.',
    placeholder_amount: 'Please enter the transfer amount',
    not_search_user_name: 'Not sure username',
    msg_select_asset_search: 'Please select an account',
    success_fail: 'Transfer has failed.',
    pls_search_asset: 'Search for assets.',
    pls_search_account: 'Search your account.',
    pls_select_asset: 'Please select an asset.',
    select_account_first: 'Please select an account first',
    select_market_first: 'Please select the market first',
    not_exist_account: "The asset's account does not exist.",
    favorites: 'Favorites',
    no_inquiry_history: 'There is no inquiry history.',
    from_user_name: 'Members of the Overdue Account',
  },
  bank_service_center: {
    title: 'title',
    date: 'date',
    state: 'state',
    enter_search_word: 'Please enter your search word',
    list: 'List',
  },
  service_center: {
    view_all: 'View all',
    contact_history: 'Contact history',
    privacy_Statement: 'Privacy Statement',
    would_you_agree: 'Would you like to agree to the above?',
    mobile_number: 'Mobile number',
    target_of_inquiry: 'Subject of inquiry',
    inquiry_contents: 'Inquiry contents',
    please_enter_your_inquiry: 'Please enter your inquiry.',
    send: 'send',
    normal_inquiries_received: 'Your inquiry has been successfully received.',
    inquiry_history: 'Inquiry history',
    pls_select_inquiry_type: 'Please select the type of contact',
    pls_login_to_use_inquiry: '1, Sign in to the first inquiries.',
    non_member_login: 'Non-member login',
    contact_id: 'Contact ID',
    view_inquiry: 'View contact',
    service_center: 'Service center',
    inquiry_details: 'Contact Details',
    msg_enter_title: 'Please enter a title.',
    msg_enter_your_content: 'Please enter your information.',
    msg_pls_login: 'Please login.',
    go_back: 'Go back',
    re_contact: 'Contact Material',
    contents: 'Contents',
    msg_no_inquiry_history: 'No contact details.',
    msg_require_login_additional_authentication:
      'You need to be logged or additional authentication.',
    when_you_member: 'When one member',
    msg_inquiry_history_can_view_after_login:
      'The members of the contact details can be viewed after logging in.',
    non_member: 'When non-members',
    lookup_inquiry: 'Contact Lookup',
    msg_enter_inquiry_id: 'Please enter the contact ID.',
    msg_enter_password_when_registering_your_inquiry:
      'Please enter the password you set when you call register.',
    frequently_asked_questions: 'Frequently Asked Questions',
    msg_enter_your_password: 'Please enter your password.',
  },
  modal: {
    not_seeing_day: 'Not seen during the day',
  },
  login_guide_modal: {
    title: 'Instructions',
    sub_title:
      'To facilitate exchanges of using your sign will cause the system to reform.',
    content:
      '[Before change] <br/> first ID Login created when you sign up <br/><br/> [After change] <br/>  being used to change the phone number or e-mail login <br/> <br/> login before the system is reorganized how are logged in as haejusimyeon submitted written first accession ID.',
  },
  affiliate: {
    affiliate_occur_list: 'Allowance History',
    affiliate_adjust_list: 'Allowance settlement details',
    allowance_balance_asset: 'Allowance cup by asset',
    list_allowance_balance_asset: 'List of allowance balance by asset',
    search_by_asset: 'Search by asset',
    allowance_search: 'Allowance search',
    generator: 'Generator',
    beneficiary: 'Beneficiary',
    benefactor: 'Benefactor',
    behavior_type: 'Behavior type',
    target_unique_number: 'Target unique number',
    date_of_occurrence: 'Date of occurrence',
    application_policy_name: 'Application policy name',
    beneficiary_type: 'Beneficiary type',
    benefactor_type: 'Benefactor type',
    target_amount: 'Target amount',
    principal_amount: 'Principal amount',
    allowance: 'Extra pay',
    allowance_assets: 'Allowance assets',
    allowance_amount: 'Allowance amount',
    affiliate_log: 'Allowance breakdown',
    allowance_settlement: 'Allowance settlement',
    allowance_settlement_info: 'Allowance settlement information',
    name_asset_settled: 'Name of assets to be settled',
    balance_receive_payment: 'Balance to be paid',
    select_account_settled: 'Select account to be settled',
    no_affiliate_log: 'There is no allowance incurred.',
    no_affiliate_balance: 'There is no list of allowance balances by asset.',
    no_affiliate_adjust: 'There is no allowance payment history.',
    asset_name: 'Asset name',
    asset_code: 'Asset code',
    balance: 'Balance',
    cumulative_amount: 'Cumulative amount',
    please_select_account: 'Please select an account.',
    calculate: 'Calculate',
    settle: 'Settle',
    calculate_amount: 'Settlement amount',
    account_number: 'Account Number',
    registration_date: 'Registration date',
    number: 'number',
  },
  Coin_name: 'Coin name',
  main_function: 'Main Function',
  disclosure_ing: 'In the process of',
  market_balance_transfer: 'Market balance transfer',
  available_after_login: 'Available after login.',
  fast_stable_deal: 'Fast and stable',
  cryptocurrency_exchange: 'Cryptocurrency exchange',
  go_transaction: 'Go Transaction',
  create_an_account: 'Open an account',
  more_than_that: ', more than that.',
  vision_title: 'Trust-based vision',
  vision_text1:
    'ONEWORLDPAY uses blockchain technology in a new digital asset ecosystem.',
  vision_text2:
    'It provides a one-stop solution to integrate with existing payment networks',
  fee_title: 'Fee benefits',
  fee_text1: 'Exemption of opening account fee,',
  fee_text2: 'account maintenance fee and buy/sell fee.',
  row_title: 'Low entry barrier',
  row_text1: 'You can trade Bitcoin,',
  row_text2: 'Ethereum and etc.',
  easy_title: 'Comfortable interface',
  easy_text1: 'A comfortable interface that beginners can easily trade.',
  easy_text2: '',
  full_time: 'Full time transaction',
  full_time_text1: 'If you have a mobile phone and computer you ',
  full_time_text2: 'can trade 24 hours a day and 365 days a year.',
  easy_sellbuy: 'Anytime, anywhere convenient transaction system.',
  so_easy: 'Easy and comfortable',
  b2c_mobile: 'B2C mobile app',
  app_sellbuy:
    'You can transact B2C anytime and anywhere through mobile phone.',
  anywhere_use: '',
  now_start_buy: 'Start trading right now.',

  procedure:
    'When logging in after accessing ONEWORLDPAY.COM/COCOBNK.COM, the approval process for information sharing is in progress, and this process is a mandatory procedure for SNS login (social login). If the login procedure through SNS is not performed, you cannot log in to ONEWORLDPAY/COCOBNK, and this procedure is carried out in accordance with the Information and Communication Network Act and the Personal Information Protection Act.',
  snslink: 'Login requested in the status of SNS account linkage is',
  four_one:
    'Article 4 ① The Minister of Science, Technology and Communication or the Korea Communications Commission establishes the foundation for the information society through promotion of the use of information and communication networks, stable management, and user protection (hereinafter referred to as "promotion of information and communication networks and information protection"). Measures must be prepared to do this.',
  four_two:
    '② The policy pursuant to Paragraph 1 shall include the following matters.  ',
  eight:
    '8. Enhancement of safety and reliability of information and communication networks',
  nine:
    '9. Other matters necessary for promotion of information and communication network use and information protection, etc.',
  execution: 'It is being implemented in accordance with its provisions.',
  privacy: 'In addition, the personal information protection law',
  twentyfour_three:
    'Article 24 (Restriction on Processing of Uniquely Identifying Information) ③ When a personal information controller processes uniquely identifying information pursuant to each of the subparagraphs of Paragraph 1, the uniquely identifying information shall not be lost, stolen, leaked, forged, altered or damaged. Measures necessary to secure safety, such as encryption, shall be taken as prescribed by Presidential Decree.',
  twentyfour_two:
    'Article 24-2 (Restrictions on the Processing of Resident Registration Numbers) ② Personal information controllers must keep their resident registration numbers safe through encryption measures so that they are not lost, stolen, leaked, forged, altered or damaged despite Article 24 (3). In this case, necessary matters concerning the subject of encryption application and application timing for each subject shall be determined by Presidential Decree, taking into account the scale of processing of personal information and the impact of leakage.',
  implemented: 'It is being implemented in accordance with its provisions.',
  we_future: 'our future',
  pop_cocobank: 'COCO BANK',
  fourth_industry: 'Leader in the fourth industry',
  oc_15: 'October 15',
  officially_open: 'Officially open!',
  head_branch_office:
    'Korea Head Office (Jamsil Branch) / 1st Branch (Sinsa Branch)',
  sep_15: 'September 15th at 5pm',
  open_popup: 'OPEN',
  thanks_for: 'Thank you for your encouragement.',

  kiosk: {
    make_pay: 'Pay',
    product_name: 'Item',
    amount_payment: 'Price',
    may_pay_guide_txt:
      "The payment will be completed after scanning <span style='font-weight:900; color:#2369b0;'>ONEWORLDPAY {os}'s payment QR code</span><br />to your device.",
    app_download_btn: 'Install ONEWORLDPAY {os}',
    app_download_qr_scan: 'Please scan the QR code to download the app.',
    app_install_txt:
      'Please scan the QR code below and install <span style="font-weight: 900; color: #1f67af">ONEWORLDPAY {os}</span>.',
    app_install_sub_txt:
      'If you scan the QR code of the ONEWORLDPAY payment page to the CTM, the payment will proceed.',
    app_install_sub_txt2: 'ONEWORLDPAY ios service will be available later.',
    direct_exchange_txt:
      '<span>Exchange</span>&nbsp;<strong>{asset1}</strong> <span>for</span> <strong>{asset2}</strong>',
    bank_use: 'Bank',
    cocobank: 'ONEWORLDPAY',
    cocobank_account_transfer: 'Transfer',
    store_use: 'Order',
    location_store: 'co.u co.u',
    home_ad_1: "World's First Coin Open Market",
    home_ad_2: 'COCO MARKET',
    use: 'How to use',
    bank_direct_ex: 'Exchange currency right away',
    deposit_inquiry: 'Inquiry',
    deposit_inquiry_txt: 'Check ONEWORLDPAY account',
    deposit_withdrawal: 'Withdrawal',
    deposit_withdrawal_txt: 'Take 10seconds to 10minutes',
    deposit_transfer: 'Transfer',
    deposit_transfer_txt: 'Transfer to ONEWORLDPAY account',
    wallet_transfer: 'Wallet Transfer',
    wallet_transfer_txt: "Transfer to other exchange's wallets",
    exchange_list: 'Currency exchange history',
    certified: 'Certification management',
    certified_drawer_title: 'Secure Authenticataion/Management',
    direct_transaction: 'Direct transaction',
    direct_transaction_txt: 'Immediately exchange',
    c2c_transaction: 'C2C transaction',
    c2c_transaction_txt: 'Customer cryptographic trading',
    account_application: 'Application for account',
    account_application_txt: 'Apply for an account',
    // account application comonent
    terms_title1:
      'Guide to Limit Limits to Prevent Strengthening Telecommunication Financial Fraud',
    terms_text1:
      'As the requested account is opened non-face-to-face, the withdrawal (transfer) limit through automated devices and the Internet is limited to 0 CCF per day.<br /> Objective authentication data to confirm the transaction purpose is presented to the branch and "management> You can cancel the limit limit in "Security Authentication/Management".<br />When using Internet banking, you must register as a withdrawal account to make transfer transactions.<br />Limit limit per cryptocurrency account is open only 5 per person You can.',
    terms_notice1: 'Notice',
    terms_notice1_txt:
      'Internet banking subscription can be applied by linking from the completion screen after opening a deposit and withdrawal account.<br />Existing Internet banking customers can register for withdrawal accounts through Internet banking only when the withdrawal account registration category is Internet + branch. Please note that there is.',
    terms_notice2:
      '&#8251; If you proceed with security authentication first, you must create an account and register as a withdrawal account when using Internet banking before you can transfer transactions.',
    cancel: 'cancel',
    security_authentication: 'Security authentication',
    new_registration: 'New registration',
    terms_title2:
      'When you click the new sign-up button, you will be issued your own {0} Cocobank account and deposit address linked to external wallet.',
    terms_notice3: 'Be sure to know before depositing!',
    terms_notice3_text1:
      'Only {0} can be deposited to the account/address issued upon new registration. Errors/losses that may occur if you attempt to deposit other digital assets to the address are irrecoverable.',
    terms_notice3_text2:
      'After one confirmation has occurred, it is reflected in the balance through the deposit process. The deposit process is automatic and the time required may vary depending on network conditions.',
    terms_notice3_text3: 'The above address is <strong>Deposit Only</strong>.',
    terms_checkbox_text: 'Did you agree and understand the above?',
    assets: 'Assets',
    favorite: 'Favorites',
    select_assets_txt: 'Please select an asset.',
    search_assets: 'Search asset',
    search_assets_txt: 'Please search for an asset.',
    account_name: 'Account name',
    account_name_txt: 'Please enter your account name',
    selected_assets: 'Optional asset',
    account_unique_number: 'Account unique number',
    account_number: 'Account Number',
    stop_amount: 'Stop amount',
    state: 'state',
    auto_input: 'Auto input',
    opening: 'Opening',
    application_success_txt: 'Account application has been completed.',
    application_fail_text: 'Account application failed.',
    confirm: 'confirm',
    previous: 'previous',
    enter_account_number: 'Please enter your account number.',
    service_preparation: 'Preparing the service',
    service_preparation_txt1:
      'We are preparing the page to provide better service.',
    service_preparation_txt2: 'We will be ready and see you soon.',
    search_account: 'Search account',
    search_account_txt: 'Please search your account.',
    select_account_txt: 'Please select an account.',
    withdrawable_amount: 'Withdrawable amount',
    inquiry_period: 'Inquiry period',
    variable_amount: 'Variable amount',
    no_deposit_history: 'There is no deposit inquiry history.',
    select_date: 'Please select a date',
    type_of_change: 'Type of change',
    sort_order: 'Sort order',
    inquiry_option: 'Inquiry option',
    select_market: 'Market selection',
    reduction_rate: 'Commission rate',
    sales_quantity: 'Sales quantity',
    minimum_purchase_quantity: 'Minimum purchase quantity',
    selling_price_per_piece: 'Selling price per piece',
    account_for_registration_of_sales: 'Account for registration of sales',
    purchase_assets: 'Purchase assets',
    available_quantity: 'Available quantity',
    purchase_quantity: 'Purchase quantity',
    price_per_piece: 'Price per piece',
    quantity_to_be_paid: 'Quantity to be paid',
    select_account_to_receive: 'Select account to receive',
    registration_was_successful: 'Registration was successful',
    registration_failed: 'Registration failed.',
    go_to_first: 'For the first time',
    purchase_history: 'Purchase history',
    purchase_price: 'Purchase price',
    no_description: 'There is no description.',
    sales_history: 'Sales history',
    price_per_quantity: 'Price per quantity',
    total_fee: 'Total fee',
    no_disclosure_details: 'There is no disclosure details.',
    advanced_search: 'Advanced Search',
    sales_registration: 'Sales registration',
    purchase_registration: 'Purchase registration',
    verification_completed: 'Verification completed',
    email_authentication: 'Email Authentication',
    authenticate: 'Authenticate',
    identity_verification: 'Identity verification',
    otp_authentication: 'OTP authentication',
    withdrawal_address_verification: 'Withdrawal address verification',
    withdrawal_address_application_details:
      'Withdrawal address application details',
    no_withdrawal_address_application_details:
      'There is no request for withdrawal address.',
    kyc_authentication: 'KYC authentication',
    kyc_application_details: 'KYC application details',
    security_level: 'Security level',
    view_rating: 'Show security level',
    no_account_alias: '(No account alias)',
    no_choice: '(No choice)',
    select_coin_to_exchange: 'Select the coin you want to exchange.',
    sending_verification_email: 'Sending verification email',
    sending_verification_email_txt: 'Click Send Verification Email.',
    enter_verification_code: 'Authenticate',
    enter_verification_code_txt: 'Please enter the verification code.',
    verification_email_has_been_sent: 'A verification email has been sent.',
    base_asset_account_information: 'Base asset account information',
    classification_of_transactions: 'Transaction classification',
    logged_out_txt: 'You are logged out.',
    check_logged_out_txt: 'Do you want to log out',
    scan_qr_code_txt: 'Please scan the QR code.',
    simple_login: 'Simple login',
    simple_login_txt: 'Enter the login veritication code.',
    be_loggin_in: 'You are logging in.',
    be_logged_in: 'You are logged in.',
    step_one: 'Step 1',
    step_one_txt: 'Install Google OTP from App store.',
    step_two: 'Step 2',
    step_two_txt:
      'Please print or write down the issued 16-digit code.This code is used for recovery in case of loss/replacement or deletion of mobile phone.',
    step_three: 'Step 3',
    step_three_txt:
      'Scan the QR code with the installed Google Authenticator app.',
    step_four: 'Step 4',
    step_four_txt:
      'Enter the generated <strong>OTP 6-digit veification code</strong> and click Authenticate.',
    mobile_authentication: 'Mobile phone authentication',
    mobile_authentication_txt:
      'Authentication is performed using a mobile phone in the name of the person.',
    do_mobile_authentication: 'Phone authentication',
    complete_mobile_authentication: 'Authentication is complete.',
    failed_mobile_authentication: 'Authentication failed.',
    transfer_quantity: 'Transfer quantity',
    enter_transfer_quantity: 'Please enter the transfer quantity.',
    transfer_quantity_2: 'Transfer quantity',
    enter_transfer_quantity_2: 'Please enter the transfer quantity.',
    select_transfer_quantity: 'Please select the transfer quantity.',
    enter_transfer_account_number: 'Please enter the transfer account number.',
    current_security_level: 'Your current security level',
    choose_how_to_pay_the_fee: 'Choose how to pay the fee',
    confirm_withdrawal_application_information:
      'Confirm withdrawal application information',
    enter_login_code_txt:
      'Please enter the login authentication code shown on the screen below.',
    direct_ex_manual: 'How to use Direct Currency Exchange',
    deposit_transfer_manual: 'How to use deposit remittance',
    deposit_inquiry_txt_manual: 'How to use deposit queries',
    deposit_withdrawal_manual: 'How to use deposit withdrawal',
    wallet_transfer_manual: 'How to use wallet transfer',
    buy_with_coin_selected_account: 'Choose the account to buy {code}.',
    sell_with_coin_selected_account: 'Choose the account to sell {code}',
    receive_purchased_coin: 'Choose the account to receive {code}.',
    receive_converted_coin: 'Choose the account to receive {code}.',
    enter_account_holder: 'Please enter the name of the account holder.',
    enter_account: 'Please enter your account number.',
    enter_withdrawal: 'Please enter the withdrawal amount.',
    transfer_to_another_wallet: 'Wallet Transfer',
    invalid_login_code: 'Invalid login authentication code.',
    payment_canceled: 'Payment has been canceled',
  },
  market_balance: {
    deposit_successful: 'The deposit was successful.',
    wthdrawal_successful: 'Withdrawal was successful.',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    select_account: 'Select account',
    assets: 'Assets',
    select_market: 'Market selection',
    quantity: 'Quantity',
    confirm: 'Confirm',
  },
  pop_notice: {
    notice_close: 'Close',
    notice_today: "Don't see today",
  },
  private_notice: {
    msg_false_deal_title: 'Prohibits false disclosure',
    msg_false_deal_content_1:
      'Sellers must have enough cryptocurrency before transaction.',
    msg_false_deal_content_2:
      'Continuous false disclosure impose restictions on the use of service.',
    msg_deal_confirm_click_title: 'Precautions for clicking Confirmed button',
    msg_deal_confirm_click_content_1:
      "The seller, be sure to click 'confirm' button, then be sure to check the payment of the buyer.",
    msg_deal_confirm_click_content_2:
      'Coco banks are not legally liable for monetary damages caused by negligence of the seller. Be sure to check whether the purchasers of pay.',
    msg_deal_confirm_not_click_title: 'If the Confirmed button is not pressed',
    msg_deal_confirm_not_click_content_1:
      'The seller pays the buyer confirm whether you must click the "Confirm" button.',
    msg_deal_confirm_not_click_content_2:
      "If you don't press the Confirmed button, administrator will restict the use of service.",
    msg_c2c_title: 'C2C transactions',
    msg_c2c_content_1:
      'C2C transactions are based on the free trade activities of the seller and the buyer.',
    msg_c2c_content_2:
      'ONEWORLDPAY only provides platform services for convenient and secure transactions.',
    msg_c2c_content_3:
      'If legal dispute arises between the seller and the buyer,ONEWORLDPAY only acts as an escrow.',
    msg_false_hold_title: 'Prohibit the holding false',
    msg_false_hold_content_1:
      "The buyer must be sure to click the 'hold' after payment has been completed for the C2C trading.",
    msg_false_hold_content_2:
      'Any dispute between the seller and the buyer arising out of the holding is not responsible for any fraudulent Coco bank.',
    msg_false_hold_content_3:
      'This restriction also applied to the use of city services continue to perform the holding false Please note that luggage.',
    msg_false_hold_content_4:
      'If there is no confirmation after completing your payment, please contact the administrator has through one-on-one contact.',
    msg_false_hold_content_5:
      'When the C2C transactions via the external wallet in case you can be charged a fee it has not carried out properly C2C transactions can be inconvenient for those transactions resolved.',
  },
  kiosk_re: {
    choice_lang: '언어선택',
    buy_immedi:
      'ONEWOLRDPAY를 이용하시면<br><span>즉시 구입</span>이 가능합니다.',
    new_acc: 'ONEWOLRDPAY 계좌만들기',
    join_txt:
      '외부지갑 및 계좌를 이용시에는 구매예약을 하여 판매자의 확인여부가 필요하나 ONEWOLRDPAY를 이용하시면 즉시 구입이 가능 하십니다. ONEWOLRDPAY내에 이동시 수수료를 받지 않으며 세상에서 가장 빠른 암호자산간 이동을 지원하고 있습니다.',
    main_order_txt: '신용카드/암호자산 매장내 구입',
    main_bank_txt: '암호자산 안전하게 보관 및 구입/판매',
    main_market_txt: '온라인 암호자산 오픈마켓',
    main_about: '어바웃코인',
    main_about_txt: '암호자산에 대한 전문뉴스',
    about_drw_txt_1:
      '빠르고 다양한 블록체인 소식을<br><span>coinabout</span>에서 받아보세요.',
    about_drw_txt_2:
      '코인어바웃은 블록체인과 핀테크에<br>대한 빠른 소식과 분석을 제공합니다.',
    about_drw_txt_3: 'QR 코드를 스캔하면 코인어바웃으로 연결됩니다.',
    market_drw_txt_1: '이제 <span>가상자산으로 쇼핑</span>하세요.',
    market_drw_txt_2:
      '저희 코코마켓은 국내 최초 가상자산으로<br>물건을 사고팔 수 있는 오픈마켓입니다.',
    market_drw_txt_3: 'QR 코드를 스캔하면 코코마켓으로 연결됩니다.',
    market_drw_txt_4:
      '코코마켓은 이후 많은 상품과  다양한 가상자산<br>결제 시스템을 구축할 예정입니다.',
    login_title: '아래 <span>QR 코드</span>를 스캔해주세요.',
    login_txt_1: '서비스 사용을 위한 사용자의 정보가 필요합니다.',
    login_txt_2:
      '단말 화면에 표시된 간편 로그인 인증 코드를 아래 입력란에 입력해주세요.',
    code_txt: '간단로그인<br> <span>인증코드</span>를 입력하세요.',
    new_acc_tit_1: '신규 계좌 생성',
    new_acc_tit_2: '신규 계좌 생성에 필요한 내용들을 확인해 주세요.',
    new_acc_txt_1: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
    new_acc_txt_2:
      '* 인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여 등급을 향상시킨 후 계좌생성 및 출금계좌등록을 진행하시기 바랍니다.',
    new_acc_txt_3:
      'ONEWOLRDPAY전용 계좌에서 계좌로 송금하면 수수료가 일체 없습니다. 신규가입시 발행되는 계좌/주소로는 {0} 만 입금 가능합니다. 해당 주소로 다른 디지털 자산을 입금 시도할 경우에 발생할 수 있는 오류/손실은 복구 불가능 합니다. 1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다. 입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요 시간이 달라 질 수 있습니다. 위 주소는 입금전용 주소입니다.',
    new_acc_txt_4:
      '회원님에게 할당된 신규가입으로는 {0} 을 입금할 수 있습니다.',
    new_acc_btn_agr: '동의 및 계좌 개설',
    new_acc_txt_5: '신규 계좌가 개설되었습니다.',
    new_acc_txt_6: '개설된 계좌로 ONEWOLRDPAY서비스를 이용가능합니다.',
    charge_tit_1: '{0}를 충전합니다.',
    charge_tit_2: '{0}충전에 사용될 자산을 선택해주세요.',
    charge_tit_3: '계좌 선택 및 충전에 사용될 자산 수량을 입력해 주세요.',
    charge_txt_1: '충전 기준율',
    charge_txt_2: '충전 유형',
    charge_txt_3: '기준 수량',
    charge_txt_4: '충전 총액',
    charge_txt_5: '충전하기',
    charge_txt_6: '충전이 완료되었습니다.',
    charge_txt_7: '3초 뒤에 메인화면으로 돌아갑니다.',
    complete: '선택완료',
    input_complete: '입력완료',
    quan_max: '최대',
    buy_reserv: '구매예약 체결',
    krw_dialog_tit: '입금후에 구매예약 체결 버튼을 클릭해 주세요.',
    krw_dialog_txt_1:
      '이전 구매예약 클릭시 지갑 및 계좌는 동결되며 구매자가 최종적으로 아래 지갑 및 계좌에 최종 지불 할 금액을 입금후에 구매예약 체결 버튼을 클릭하셔야만 판매자에게 알림이 가며 판매자가 구매확인 하는 순간 구입자의 지갑 및 계좌에 구매하신 자산이 입금 됩니다.',
    krw_dialog_txt_2:
      '* 입금이 3시간 안에 구매예약 체결이 되지 않으면 동결된 지갑 및 계좌가 사용가능 하게 됩니다. 단, 입금하고 1시간 에서 2시간 안에 입금이 되지 않으면 고객센터에 연락주시기 바랍니다.',
    krw_dialog_txt_3:
      '구매자는 예약만 하고 입금이 3회 이상 되지 않으면 아이디가 정지됩니다.',
  },
}
